import { Helmet } from "react-helmet-async";
import { Link as RouterLink } from "react-router-dom";
// @mui
import { styled } from "@mui/material/styles";
import { Button, Typography, Container, Box } from "@mui/material";

// ----------------------------------------------------------------------

const StyledContent = styled("div")(({ theme }) => ({
  maxWidth: 480,
  margin: "auto",
  minHeight: "100vh",
  display: "flex",
  justifyContent: "center",
  flexDirection: "column",
  padding: theme.spacing(12, 0),
}));

// ----------------------------------------------------------------------

export default function Page404() {
  return (
    <>
      <Helmet>
        <title> 404 Page Not Found </title>
      </Helmet>

      <Container>
        <StyledContent sx={{ textAlign: "center", alignItems: "center" }}>
          <Typography variant="h3" paragraph color="textSecondary" sx={{ letterSpacing:'-0.02rem'}}>
            Sorry, page not found!
          </Typography>

          <Typography sx={{ color: "#6c90a2", fontWeight:500 }}>
            Sorry, we couldn’t find the page you’re looking for. Perhaps you’ve
            mistyped the URL? Be sure to check your spelling.
          </Typography>

          <Box
            component="img"
            src="/assets/illustrations/illustration_404.svg"
            sx={{ height: 330, mx: "auto", my: { xs: 5, sm: 10 } }}
          />

          <Button
            to="/dashboard/app"
            size="large"
            variant="contained"
            component={RouterLink}
            sx={{
              backgroundColor: "#48768C",
              color: "#fff",
              fontWeight: 600,
              "&:hover": {
                backgroundColor: "#3B5F72", // Slightly darker shade of the main color
              },
            }}
                    >
            Return to Dashboard
          </Button>
        </StyledContent>
      </Container>
    </>
  );
}
